import $ from "jquery";
import _ from "underscore";
import QuoteStore, {mockPayload as quotesMockPayload} from "../stores/QuoteStore";
import AsnStore from "../stores/AsnStore";
import {successGET, successStoreGET, errorStoreGET} from "./utilities";

let ajaxFunc = $.ajax;
const TEST = false;

function ajaxable({returnableFn, success, error}){
  if(TEST){
    const timeoutToken = setTimeout(function(){
      success(returnableConstantsMap[returnableFn]());
    }, 500);

    return {
      abort: function(){
        clearTimeout(timeoutToken);
      }
    };
  }
  else{
    $.ajax(_.omit(...arguments, "returnableFn"));
  }
}
 

export function fetchShippingQuotesForAsnData(asnId, asnData, url){
  const asn = AsnStore.getDataViaId(asnId);
  if(asn.isFetchingQuotes){
    console.log("already fetching shipping quotes");
    return false;
  }

  const deferred = $.Deferred();
  AsnStore.resetQuotesRelatedFlags(asn, {isFetchingQuotes: true});
  // AsnStore.updateObjectAndEmit(asnId, {isFetchingQuotes: true, quotesAreValid: null, showQuotesRemovedBecauseInfoChangedMessage: null});
  AsnStore.emitEvent("fetchingQuotes");

  const xhr = ajaxable({
    returnableFn: "QUOTES_MOCK_DATA",
    data: asnData,
    url: url,
    dataType:"JSON",
    type: 'POST',
    success: _.partial(successGET, deferred),
    error: _.partial(errorStoreGET, deferred, QuoteStore),
  });

  const xhrSetup = xhrListenerSetup(xhr);
  xhrSetup.bindListener();

  deferred.always(_.partial(fetchShippingQuotesForAsnDataComplete, asnId, xhrSetup));
  deferred.fail(_.partial(fetchShippingQuotesForAsnDataFail, asnId));
  deferred.then(_.partial(handleAsnQuotesOrSpecialQuoteNoteSuccess, asnId));

  

  // return xhr;
}

window.fetchShippingQuotesForAsnData = fetchShippingQuotesForAsnData;


function fetchShippingQuotesForAsnDataComplete(asnId, xhrSetup){
  // console.log('shipping quote fetching complete');
  xhrSetup.unbindListener();
}

function fetchShippingQuotesForAsnDataFail(asnId, store, xhr, status){
  if(status === "abort"){
    console.log('aborted');
    AsnStore.updateObjectAndEmit(asnId, {quoteId: null, optionId: null, quotesAreValid: null, showQuotesRemovedBecauseInfoChangedMessage: null, isFetchingQuotes: false, requestQuoteSuccess: null});
  }
  else{
    AsnStore.updateObjectAndEmit(asnId, {quoteId: null, optionId: null, quotesAreValid: null, showQuotesRemovedBecauseInfoChangedMessage: null, isFetchingQuotes: false, requestQuoteSuccess: false});
  }
}

function handleAsnQuotesOrSpecialQuoteNoteSuccess(asnId, data){
  QuoteStore.normalizeAndStoreData(data);
  const quotes = data.quotes;
  const quoteIds = QuoteStore.pluckIdsFromArray(quotes);
  if(quoteIds.length){
    QuoteStore.setAttrsForIds(quoteIds, {asnId});
  }
  AsnStore.updateObjectAndEmit(asnId, {quoteId: null, optionId: null, quotesAreValid: true, showQuotesRemovedBecauseInfoChangedMessage: null, isFetchingQuotes: false, requestQuoteSuccess: true, specialQuote: data.specialQuote, quotesRefId: data.quotesRefId});
}


function xhrListenerSetup(xhr){

  const abortNow = ()=>{
    xhr.abort();
  };

  const bindListener = ()=>{
    
  };
  const unbindListener = ()=>{

  };

  return {
    bindListener,
    unbindListener
  }
}




const returnableConstantsMap = {
  QUOTES_MOCK_DATA: ()=>{
    return quotesMockPayload;
  },
  SPECIAL_QUOTE_DATA: ()=>{
    return {quotes: [], specialQuote: true, quotesRefId: 5};
  }
}


// WEBPACK FOOTER //
// ./src/actions/quotes.js